import { colorsPalettes } from "@similarweb/styles";
import { PageTitlePlaceholderLoader, PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const InsightCardLoader = () => (
    <Flex
        flexDirection="column"
        alignItems="flex-start"
        gap="8px"
        background={colorsPalettes.carbon[0]}
        border={`1px solid ${colorsPalettes.carbon[50]}`}
        borderRadius="6px"
        padding="12px"
        flex="1"
        minWidth="0"
        height="90px"
    >
        <PageTitlePlaceholderLoader />
        <PixelPlaceholderLoader
            width="100%"
            height="40px"
        />
    </Flex>
);
